import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class KullanimSekliListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KullanimSekliListe";
    super(baseUrl);
  }


  getKullanimSekliListe(kullanimSekliKodu?: number){
    return this.get("", { params: { kullanimSekliKodu: kullanimSekliKodu } })

  }

}
export default new KullanimSekliListeAPI();
class KullanimSekliListeRequest {
  public kullanimSekliKodu?: number;

  constructor(kullanimSekliKodu?: number,) {
   
      this.kullanimSekliKodu = kullanimSekliKodu;

  }
}
export { KullanimSekliListeRequest };